
export class StateSelectOption {
  id: number;
  name: string;
  code: string;
  country_code: string;
}
